import { render } from "./orders_page.vue?vue&type=template&id=173da86e"
import script from "./orders_page.vue?vue&type=script&lang=js"
export * from "./orders_page.vue?vue&type=script&lang=js"

import "./orders_page.vue?vue&type=style&index=0&id=173da86e&lang=scss"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__